import { PRODUCT_SAVINGS_ACCOUNTS } from '@/constants/products';
import { getProviders } from '@/graphql/queries/shared/institution';
import lang from '@/lang/middleware/products/banking/savings-accounts';

export default async ({ $apolloQuery, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  await $apolloQuery(getProviders, { product: PRODUCT_SAVINGS_ACCOUNTS }).then(providers => {
    const description = store.$i18n.t('providers.description');
    const subtitle = store.$i18n.t('providers.subtitle');
    const title = store.$i18n.t('providers.title');
    store.commit('jumbotron/SET_JUMBOTRON', { subtitle, title, type: 'generic' });
    store.commit('providers/setList', providers);
    store.commit('pageContent/setHead', { description, title });
  });
};
